export const skillsData = [
    'HTML',
    'Javascript',
    'CSS',
    'React',
    'Node',
    'Bootstrap',
    'Ubuntu',
    'MongoDB',
    'Tailwind',
    'MySQL',
    'MaterialUI',
    'ChakraUI'
]

